import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Auth.css";

const AuthCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { applyToken } = useAuth();

  useEffect(() => {
    const token = params.get("token");
    const error = params.get("error");
    const returnUrl = params.get("returnUrl");

    if (error) {
      navigate(`/login?error=${encodeURIComponent(error)}`);
      return;
    }

    if (!token) {
      navigate("/login?error=Sign-in%20response%20was%20incomplete");
      return;
    }

    applyToken(token).then(() => {
      if (returnUrl) {
        window.location.href = returnUrl;
      } else {
        navigate("/dashboard", { replace: true });
      }
    });
  }, [applyToken, navigate, params]);

  return <div className="auth-container">Completing sign-in...</div>;
};

export default AuthCallback;
